import React from 'react'
import { Link } from 'react-router-dom'
import { Modal } from '../../elements'

const MessageDeliveryConfirmationModal = (props) => {
  const { isModalOpen, recipientName, handleModalClose, chatSessionUUID } = props
  return (
    <Modal
      header={<div className="has-text-centered">Message Sent</div>}
      show={isModalOpen}
      onClose={handleModalClose}
      showClose={true}
      closeOnBlur={true}
      closeOnEsc={true}
    >
      <h5 className="pt-5 pb-5 has-text-centered">We will notify you when {recipientName} responds.</h5>
      <Link to="/" className="is-primary button is-fullwidth">
        Continue Searching
      </Link>
      <Link to={`/conversations/${chatSessionUUID}`} className="mt-2 is-secondary button is-fullwidth">
        View Message
      </Link>
    </Modal>
  )
}

export default MessageDeliveryConfirmationModal
